import React, { useState, useEffect } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField, Tooltip, CircularProgress, Checkbox, Box, Typography, Switch } from "@material-ui/core"
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from "@material-ui/pickers"
import { DropzoneArea } from "material-ui-dropzone";
import CloseIcon from "@material-ui/icons/Close"
import MomentUtils from "@date-io/moment"
import AttachmentIcon from '@material-ui/icons/Attachment';
import InfoIcon from '@material-ui/icons/Info';
import GetAppIcon from '@material-ui/icons/GetApp';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { backendDateFormat, dayMonthDateFormat } from "../../../constants"
import moment from "moment";
import { useSnackbar } from 'notistack';
import { format_Commas } from "../../../utils";
import { globalPutService, globalPostService, globalGetService, globalFileUploadService, globalDeleteService } from '../../../utils/globalApiServices';
import { PageLoader, DeletePopUp } from '../../../shared_elements';
import { regexConstants } from '../../../constants/regEx';
import { checkApiStatus } from '../../../utils'
import { fleetAdObj, StepperFile, AssessmentList } from '.';
import { specificKey, specificMessTsn, specificMessCsn } from '../../camo';
import { trackActivity } from '../../../utils/mixpanel';
import { smbcInstance,acumenCamo } from '../../../shared_elements/components';
function AddEditFleetAD({ toggleModalFn, fleetData, modeType, getResponseBack }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [error, setError] = useState({})
    const [isLoading, setLoading] = useState(false)
    const [egineFamily, setEngineFamily] = useState([])
    const [data, setData] = useState(fleetData ? fleetData : fleetAdObj)
    const [applicability, setApplicability] = useState([])
    const [engineFamilyCache, setEngineFamilyCache] = useState({});
    const [removedEngineTypeIds, setRemovedEngineTypeIds] = useState(new Set());
    const [uploadFile, setUploadFile] = useState(false)
    const [assessmentData, setAssessmentData] = useState({})
    const [assessmentFinalSave, setAsseementFinalSave] = useState({ modal: false })

    useEffect(() => {
        getEngineFamily()
        // if (data?.engine_family) {
        //     debugger
        //     onChangeEngineFamily('engine_family', data?.engine_family)
        // }
        // else{
        //      getApplicability()
        // }
    }, []);
    const onChangeEngineFamily = async (keyParam, value) => {
        if (keyParam === 'engine_family' && (!value || value.length === 0)) {
            setData(prev => ({
                ...prev,
                engine_family: [],
                applicability: []
            }));
            setApplicability([]); // reset dropdown options
            setEngineFamilyCache({});
            setRemovedEngineTypeIds(new Set());
            return;
        }
        const prevFamilies = data?.engine_family || [];
        const addedFamilies = value?.filter(v => !prevFamilies.some(p => p.id === v.id));
        const removedFamilies = prevFamilies.filter(p => !value.some(v => v.id === p.id));

        // Handle partial deselection
        if (removedFamilies.length > 0) {
            const updatedCache = { ...engineFamilyCache };
            removedFamilies?.forEach(family => {
                delete updatedCache[family?.id];
            });

            const remainingEngineTypes = (data?.applicability || []).filter(item =>
                value.some(family => updatedCache[family.id]?.some(engine => engine.id === item.id))
            );

            setRemovedEngineTypeIds(prev => {
                const newSet = new Set(prev);
                removedFamilies.forEach(family => {
                    const familyEngineTypes = engineFamilyCache[family?.id] || [];
                    familyEngineTypes.forEach(engineType => {
                        newSet.delete(engineType?.id);
                    });
                });
                return newSet;
            });

            setEngineFamilyCache(updatedCache);

            // Update BOTH selected and dropdown options
            const allAvailableEngineTypes = value?.flatMap(family => updatedCache[family?.id] || []);
            setApplicability(allAvailableEngineTypes);

            setData(prev => ({
                ...prev,
                [keyParam]: value,
                applicability: remainingEngineTypes
            }));
            return;
        }

        // Handle added families
        try {
            const updatedCache = { ...engineFamilyCache };
            const familiesToFetch = addedFamilies?.filter(family => !updatedCache[family?.id]);

            if (familiesToFetch?.length > 0) {
                const responses = await Promise.all(
                    familiesToFetch?.map(family =>
                        globalGetService(`camo/engine_dropdown/${family?.id}/`)
                    )
                );

                responses.forEach((res, index) => {
                    if (checkApiStatus(res)) {
                        updatedCache[familiesToFetch[index]?.id] =
                            res.data?.data?.engine_type || [];
                    }
                });
            }

            setEngineFamilyCache(updatedCache);

            const allEngineTypes = value?.flatMap(family => updatedCache[family?.id] || []);
            const validEngineTypes = allEngineTypes?.filter(item => !removedEngineTypeIds?.has(item.id));

            const uniqueEngineTypes = [...new Map(validEngineTypes?.map(item => [item.id, item]))?.values()];

            const existingSelections = (data?.applicability || []).filter(
                item => validEngineTypes.some(e => e.id === item.id)
            );
            const newSelections = uniqueEngineTypes.filter(
                item => !existingSelections?.some(e => e.id === item.id)
            );

            const newApplicability = [...existingSelections, ...newSelections];

            // Update dropdown options
            setApplicability(uniqueEngineTypes);

            setData(prev => ({
                ...prev,
                [keyParam]: value,
                applicability: newApplicability
            }));

        } catch (error) {
            console.error("Error fetching engine types:", error);
            setData(prev => ({ ...prev, [keyParam]: value }));
        }
    };


    const onFieldChange = (keyParam, value) => {
        if (keyParam === "applicability") {
            const currentIds = new Set((data.applicability || []).map(i => i.id));
            const newIds = new Set(value.map(i => i.id));

            setRemovedEngineTypeIds(prev => {
                const updated = new Set(prev);

                // Add newly removed IDs
                currentIds.forEach(id => {
                    if (!newIds.has(id)) updated.add(id);
                });
                // Remove re-added IDs
                newIds.forEach(id => {
                    if (updated.has(id)) updated.delete(id);
                });

                return updated;
            });
            setData(prev => ({ ...prev, [keyParam]: value }));
        } else if (keyParam === "attachments") {
            if (Array.isArray(value)) {
                setData(prev => ({
                    ...prev,
                    attachments: [...(prev.attachments || []), ...value]
                }));
            }
        } else if (keyParam === "esn_range") {
            setData(prev => ({ ...prev, [keyParam]: value, ['esn_list']: null, ['esnFrom']: null, ['esnTo']: null }));
        }
        else {
            setData(prev => ({ ...prev, [keyParam]: value }));
        }
    };
    const onRestErrorKey = (keyParam) => {
        setError({ [keyParam]: '' })
    }
    const getEngineFamily = () => {
        globalGetService(`camo/engine_dropdown/`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setEngineFamily(response?.data?.data?.engine_family)
                }
            })
    }
    // const getApplicability = () => {
    //     globalGetService(`console/engine-types/`)
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 setApplicability(response?.data?.data?.engineTypes)
    //             }
    //         })
    // }
    const onAddNewAsset = (finalSave) => {
        let validationInputs = {}
        if (!smbcInstance) {
            validationInputs = {
                ...validationInputs,
                ata: data?.ata ? '' : "Please Enter ATA",
                faa_ad: acumenCamo ? data?.faa_ad ? '' : "Please Enter FAA AD" : '',
                easa_ad: acumenCamo ? data?.easa_ad ? '' : "Please Enter EASA AD" : '',
                // ad_no: data?.ad_no ? '' : "Please Enter AD Refrence Number",
                description:acumenCamo ? '': data?.description ? '' : "Please Enter Description",
                // effective_date: data?.effective_date ? '' : "Please Enter Effective Date",
                type: (data?.ad_assessment || acumenCamo) ? '': data?.type ? '' : "Please Enter Type",
                workorder: (data?.ad_assessment || acumenCamo) ? '': data?.ad_compliance_status === "NOT APPLICABLE" || data?.workorder ? '' : "Please Enter Workorder",
                ref_documents:(data?.ad_assessment || acumenCamo )? '':  data?.ref_documents ? '' : "Please Enter Reference Documents",
                ad_compliance_dfp: (data?.ad_assessment || acumenCamo) ? '': data?.ad_compliance_dfp ? '' : "Please Enter Select DFP"
            }
        }
        if (!data?.ad_compliance_status === "NOT APPLICABLE") {
            if (!['NA', 'N/A', 'Unknown', 'UNK'].includes(data?.ad_compliance_tsn?.toUpperCase()) && !regexConstants.numberWithDotRegex.test(data?.ad_compliance_tsn)) {
                validationInputs.ad_compliance_tsn = "Allow Keywords NA, N/A,Unknown,or UNK,or numeric values up to 2 decimal place";
            }
            if (!['NA', 'N/A', 'Unknown', 'UNK'].includes(data?.ad_compliance_csn?.toUpperCase()) && !/^[0-9]*(\.\d{0,0})?$/.test(data?.ad_compliance_csn)) {
                validationInputs.ad_compliance_csn = "Allow Keywords NA, N/A,Unknown,or UNK,or numeric values";
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            const { remaining, checklist, next_due_note, due_date, last_done_date, last_done_fh, last_done_fc, dimension_type, dimension_interval, dimension_interval_days, dimension_interval_fc, ...payload } = data || {};
            if (data?.id) {
                delete payload?.ad_assessment_status
                finalSave === "finalSave" && delete payload?.ad_compliance_status
                globalPutService(`camo/fleet_ad/${payload.id}/`, {
                    ...payload,
                    asset_type_id: 2,
                    engine_family: payload?.engine_family ? payload?.engine_family : '',
                    applicability: payload?.applicability ? payload?.applicability?.map(item => item?.id).join(',') : '',
                    ad_compliance_tsn: payload.ad_compliance_tsn ? payload?.ad_compliance_tsn : null,
                    ad_compliance_csn: payload.ad_compliance_csn ? payload?.ad_compliance_csn.toString().replace(",", "") : null,
                    ad_assessment: payload?.ad_assessment || false,
                    esn_range: payload?.esn_range || false,
                    esn_list: payload?.ad_assessment ? payload?.esn_range ? `${data?.esnFrom} - ${data?.esnTo}` : payload?.esn_list : null,
                    part_number_list: payload?.ad_assessment ? payload?.part_number_list : null,
                    serial_number_list: payload?.ad_assessment ? payload?.serial_number_list : null,
                    submit_btn_type:finalSave === "PROCESS" ? "PROCESS" : finalSave === "finalSave" ? "SAVE_CHANGES" : "SAVE" 
                })
                    .then(response => {
                        setLoading(false)
                        if (checkApiStatus(response)) {
                            if (finalSave === "finalSave") {
                                getResponseBack()
                            } else {
                                enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                                toggleModalFn(); getResponseBack()
                            }
                            if (data?.attachments?.length) {
                                importFile(response?.data?.data)
                            }
                            trackActivity('Fleet AD Data Updated Success - Airworthiness Management', {
                                event_type: 'Fleet AD Updated Success',
                                page_title: 'Fleet AD',
                                updated_id: data?.id,
                                success_msg: response?.data?.message
                            })
                        } else {
                            if (finalSave === "finalSave") {
                            } else {
                                enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
                            }
                            trackActivity('Fleet AD Data Updated Failed - Airworthiness Management', {
                                event_type: 'Fleet AD Updated Failed',
                                page_title: 'Fleet AD',
                                updated_id: data?.id,
                                error_msg: response?.data?.message
                            })
                        }
                    })
            } else {
                const esnList = payload?.esn_list?.trim();
                const partNumberList = payload?.part_number_list?.trim();
                const serialNumberList = payload?.serial_number_list?.trim();
                if (payload?.ad_assessment && !esnList && !partNumberList && !serialNumberList) {
                     setLoading(false)
                     enqueueSnackbar( "Please Enter ESN, Part Number, or Serial Number.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } } );
                    return;
                }
                globalPostService(`camo/fleet_ad/`, {
                    ...payload,
                    asset_type_id: 2,
                    engine_family: payload?.engine_family ? payload?.engine_family : '',
                    applicability: payload?.applicability ? payload?.applicability?.map(item => item?.id).join(',') : '',
                    ad_compliance_tsn: payload.ad_compliance_tsn ? payload?.ad_compliance_tsn : null,
                    ad_compliance_csn: payload.ad_compliance_csn ? payload?.ad_compliance_csn.toString().replace(",", "") : null,
                    ad_assessment: payload?.ad_assessment || false,
                    esn_range: payload?.esn_range || false,
                    esn_list: payload?.ad_assessment ? payload?.esn_range ? `${data?.esnFrom} - ${data?.esnTo}` : payload?.esn_list : null,
                    part_number_list: payload?.ad_assessment ? payload?.part_number_list : null,
                    serial_number_list: payload?.ad_assessment ? payload?.serial_number_list : null,
                    submit_btn_type:finalSave === "PROCESS" ? "PROCESS" : finalSave === "finalSave" ? "SAVE_CHANGES" : "SAVE" 
                })
                    .then(response => {
                        setLoading(false)
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                            toggleModalFn(); getResponseBack()
                            if (data?.attachments?.length) {
                                importFile(response?.data?.data)
                            }
                            trackActivity('Fleet AD Data Updated Success - Airworthiness Management', {
                                event_type: 'Fleet AD Data Updated Success',
                                page_title: 'Fleet AD Data',
                                updated_id: data?.id,
                                success_msg: response?.data?.message
                            })
                        } else {
                            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                            trackActivity('Fleet AD  Data Updated Failed - Airworthiness Management', {
                                event_type: 'Fleet AD  Updated Failed',
                                page_title: 'Fleet AD',
                                updated_id: data?.id,
                                error_msg: response?.data?.message
                            })
                        }
                    })

            }
        } else {
            setError(validationInputs)
        }
    }
    const importFile = (item) => {
        var formData = new FormData();
        Object.keys(data?.attachments?.length > 0 && data?.attachments.filter(item => item instanceof File)).map((key) => {
            formData.append("[" + key + "]file", data?.attachments.filter(item => item instanceof File)[key])
            formData.append("[" + key + "]file_type", data?.attachments.filter(item => item instanceof File)[key].type)
            formData.append("[" + key + "]file_name", data?.attachments.filter(item => item instanceof File)[key].name)
            formData.append("[" + key + "]module_id", item?.id)
            formData.append("[" + key + "]module_type_id", 14)
            formData.append("[" + key + "]asset_type_id", 2)
        })
        globalFileUploadService(`camo/attachment/upload/?fleet=ad`, formData)
            .then(response => {
                if (checkApiStatus(response)) {
                    toggleModalFn(); getResponseBack()
                    trackActivity('Fleet AD Attachment Added Success - Airworthiness Management', {
                        event_type: 'Fleet AD  Attachment Success',
                        page_title: 'Fleet AD Import',
                        success_msg: response?.data?.message
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Fleet AD  Data Attachment Failed - Airworthiness Management', {
                        event_type: 'Fleet AD  Attachment Failed',
                        page_title: 'Fleet AD',
                        error_msg: response?.data?.message
                    })
                }
            })

    }
    const onRemoveUploadFile = (files) => {
        if (!files?.id) {
            setData({ ...data, attachments: data?.attachments.filter(item => item.name !== files.name) });
        } else {
            globalDeleteService(`camo/attachment/${files?.id}/delete/?fleet=ad`)
                .then((response) => {
                    if (checkApiStatus(response)) {
                        setData({ ...data, attachments: data?.attachments.filter(item => item.name !== files.name) })
                        getResponseBack()
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    } else {
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });

                    }
                })
        }
    }
    const [esnFrom, esnTo] = data?.esn_list ? data.esn_list.split("-") : ["", ""];

    const onChangeAssessment = (keyParam, value, index) => {
        setAssessmentData((prev) => {
            if (keyParam === "reduced_limit") {
                return {
                    ...prev,
                    result: prev?.result?.map((item, i) => i === index ? { ...item, ["reduced_limit"]: value ? parseInt(value) : value } : item)
                };
            } else {
                return {
                    ...prev,
                    result: prev?.result?.map((item, i) => i === index ? { ...item, [keyParam]: value } : item)
                };
            }

        });
    };
    const activeActiveApplicabilty = (esnList) => {
        globalGetService(`camo/assets_as_per_applicability/?applicability=${data?.applicability?.map(item => item?.id).join(',')}&esn_list=${esnList}`)
            .then(response => {
                if (checkApiStatus(response)) {
                } else {
                    if (response?.data?.data?.length) {
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    }
                }
            })
    }
    const onSaveChanges = () => {
        setLoading(true)
        const payloadArray = Object.values(assessmentData?.result || {});
        let mainpayload = Object.assign({}, data)
        delete mainpayload?.id
        globalPostService(`camo/fleet_ad_assessment/bulk/${data?.id}/`, { assessment_data: payloadArray, ad_status_data: mainpayload })
            .then(response => {
                setLoading(false)
                if (checkApiStatus(response)) {
                    setTimeout(() => {
                        onAddNewAsset("finalSave")
                    }, 300)
                    toggleModalFn(); getResponseBack()
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                }
            })
    }

    return (
        <>
            <Dialog
                open={true}
                onClose={toggleModalFn}
            >
                <DialogTitle> {modeType === "edit" ? "Edit Fleet AD" : "Add Fleet AD"} </DialogTitle>
                <DialogContent dividers>
                    {data?.id && !data?.ad_assessment ? null : <><Checkbox
                        name={data?.ad_assessment}
                        color="primary"
                        size="small"
                        onChange={(e) => onFieldChange("ad_assessment", e.target.checked)}
                        checked={data?.ad_assessment}
                        disabled={data?.assessment_job_id}
                    />AD Assessment</>}
                    <Grid spacing={1} container>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="ATA Chapter"
                                margin='normal'
                                id="ata"
                                fullWidth
                                value={data?.ata}
                                required={!smbcInstance}
                                error={error?.ata ? true : false}
                                inputProps={{ maxLength: 200 }}
                                InputLabelProps={{ shrink: true }}
                                helperText={error?.ata ? error?.ata : ""}
                                onChange={(e) => { onFieldChange("ata", e.target.value); onRestErrorKey("ata") }}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        {/* {smbcInstance ? <> */}
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                required={acumenCamo}
                                variant="outlined"
                                margin='normal'
                                label="FAA AD"
                                id="faa_ad"
                                inputProps={{ maxLength: 256 }}
                                fullWidth
                                value={data?.faa_ad}
                                error={error?.faa_ad ? true : false}
                                helperText={error?.faa_ad ? error?.faa_ad : ""}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => onFieldChange("faa_ad", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                required={acumenCamo}
                                variant="outlined"
                                margin='normal'
                                label="EASA AD"
                                id="easa_ad"
                                inputProps={{ maxLength: 256 }}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={data?.easa_ad}
                                error={error?.easa_ad ? true : false}
                                helperText={error?.easa_ad ? error?.easa_ad : ""}
                                onChange={(e) => onFieldChange("easa_ad", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        {/* </>
                            :
                            <>
                                <Grid item xs={12} md={3} sm={3}>
                                    <TextField
                                        variant="outlined"
                                        margin='normal'
                                        label="AD Reference Number"
                                        id="ad_no"
                                        fullWidth
                                        value={data?.ad_no}
                                        required={!smbcInstance}
                                        error={error?.ad_no ? true : false}
                                        helperText={error?.ad_no ? error?.ad_no : ""}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => { onFieldChange("ad_no", e.target.value); onRestErrorKey("ata") }}
                                    />

                                </Grid>
                                <Grid item xs={12} md={3} sm={3}>
                                    <Autocomplete
                                        id="ad_type"
                                        options={applicability || []}
                                        getOptionLabel={(option) => option?.name}
                                        value={data?.applicability || []}
                                        margin='normal'
                                        multiple={true}
                                        onChange={(e, value) => onFieldChange("applicability", value)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Applicability"
                                                margin='normal'
                                                placeholder="Select Applicability"
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </Grid>
                            </>
                        } */}
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                label="Issuing Authority"
                                variant="outlined"
                                margin='normal'
                                fullWidth
                                id="issuing_authority"
                                inputProps={{ maxLength: 200 }}
                                value={data?.issuing_authority}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => onFieldChange("issuing_authority", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                    </Grid>
                    {/* {smbcInstance &&  */}
                    <Grid spacing={1} container>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="FAA Superseded"
                                margin='normal'
                                fullWidth
                                name="faa_superseded"
                                inputProps={{ maxLength: 256 }}
                                value={data?.faa_superseded}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => onFieldChange("faa_superseded", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}

                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="EASA Superseded"
                                name="easa_superseded"
                                margin='normal'
                                inputProps={{ maxLength: 256 }}
                                fullWidth
                                value={data?.easa_superseded}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => onFieldChange("easa_superseded", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}

                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6}>
                            <TextField
                                variant="outlined"
                                label="Related Document"
                                margin='normal'
                                name="related_document"
                                inputProps={{ maxLength: 550 }}
                                fullWidth
                                value={data?.related_document}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => onFieldChange("related_document", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                    </Grid>
                    {/* } */}
                    {/* {smbcInstance && */}
                    <Grid spacing={1} container>
                        <Grid item xs={12} md={3} sm={3}>
                            <Autocomplete
                                id="engine_family"
                                options={egineFamily || []}
                                getOptionLabel={(option) => option?.name}
                                value={data?.engine_family || []}
                                margin='normal'
                                multiple={true}
                                disabled={data?.assessment_job_id || modeType === "edit" && fleetData?.engine_family?.length}
                                onChange={(e, value) => onChangeEngineFamily("engine_family", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <span style={{ verticalAlign: 'super' }}>
                                                Engine Family
                                                <Tooltip placement='right' title="Select Engine Family to apply all Engine Types under the family to Applicability" arrow>
                                                    <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        margin='normal'
                                        placeholder="Select Engine Family"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={9} sm={9}>
                            <Autocomplete
                                id="ad_type"
                                options={applicability || []}
                                getOptionLabel={(option) => option?.name}
                                value={data?.applicability || []}
                                margin='normal'
                                multiple={true}
                                disabled={data?.assessment_job_id || modeType === "edit" && fleetData?.applicability?.length}
                                disableCloseOnSelect={true}
                                onChange={(e, value) => onFieldChange("applicability", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Applicability"
                                        margin='normal'
                                        placeholder="Select Applicability"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    {/* } */}
                    <Grid spacing={1} container>
                        <Grid item xs={12} md={12} sm={12}>
                            <TextField
                                label="Description"
                                variant="outlined"
                                name="description"
                                margin='normal'
                                fullWidth
                                multiline
                                required={acumenCamo ? false :!smbcInstance }
                                value={data?.description}
                                InputLabelProps={{ shrink: true }}
                                error={error?.description ? true : false}
                                helperText={error?.description ? error?.description : ""}
                                onChange={(e) => { onFieldChange("description", e.target.value); onRestErrorKey("description") }}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                    </Grid>
                    <Grid spacing={1} container>
                        <Grid item xs={12} md={3} sm={3}>
                            <Autocomplete
                                id="ad_type"
                                options={['Engine']}
                                getOptionLabel={option => option}
                                value={data?.ad_type || null}
                                margin='normal'
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                                onChange={(e, value) => onFieldChange("ad_type", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="AD Type"
                                        margin='normal'
                                        placeholder="Select AD Type"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Effectivity"
                                name="effectivity"
                                id="effectivity"
                                fullWidth
                                margin='normal'
                                value={data?.effectivity}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 550 }}
                                onChange={(e) => onFieldChange("effectivity", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="SB Number"
                                id="sb_number"
                                fullWidth
                                margin='normal'
                                inputProps={{ maxLength: 200 }}
                                error={error?.sb_number ? true : false}
                                InputLabelProps={{ shrink: true }}
                                helperText={error?.sb_number ? error?.sb_number : ""}
                                value={data?.sb_number}
                                onChange={(e) => { onFieldChange("sb_number", e.target.value); onRestErrorKey("sb_number") }}
                                disabled={data?.ad_assessment_status === "COMPLETED"}

                            />
                        </Grid>
                        {/* {smbcInstance ?
                            <> */}
                        <Grid item xs={12} md={3} sm={3}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    label="FAA Effective Date"
                                    inputVariant="outlined"
                                    margin='normal'
                                    format={dayMonthDateFormat}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    minDate={moment().subtract(25, "years")}
                                    maxDate={moment().add(2, "years")}
                                    error={false}
                                    helperText={""}
                                    value={data?.faa_effective_date || null}
                                    onPaste={(event) => event.preventDefault()}
                                    onChange={(data) => onFieldChange("faa_effective_date", moment(data).isValid() ? moment(data).format(backendDateFormat) : null)}
                                    disabled={data?.ad_assessment_status === "COMPLETED"}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    label="EASA Effective Date"
                                    inputVariant="outlined"
                                    format={dayMonthDateFormat}
                                    fullWidth
                                    margin='normal'
                                    InputLabelProps={{ shrink: true }}
                                    minDate={moment().subtract(25, "years")}
                                    maxDate={moment().add(2, "years")}
                                    error={false}
                                    helperText={""}
                                    onPaste={(event) => event.preventDefault()}
                                    value={data?.easa_effective_date || null}
                                    onChange={(data) => onFieldChange("easa_effective_date", moment(data).isValid() ? moment(data).format(backendDateFormat) : null)}
                                    disabled={data?.ad_assessment_status === "COMPLETED"}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        {/* </>
                            :
                            <Grid item xs={12} md={3} sm={3} >
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        label="Effective Date"
                                        id="effective_date"
                                        margin='normal'
                                        inputVariant="outlined"
                                        required={!smbcInstance}
                                        format={dayMonthDateFormat}
                                        fullWidth
                                        disableFuture
                                        InputLabelProps={{ shrink: true }}
                                        minDate={moment().subtract(25, "years")}
                                        error={error?.effective_date ? true : false}
                                        helperText={error?.effective_date ? error?.effective_date : ""}
                                        value={data?.effective_date || null}
                                        onPaste={(event) => event.preventDefault()}
                                        onChange={(data) => { onFieldChange("effective_date", moment(data).isValid() ? moment(data).format(backendDateFormat) : null); onRestErrorKey("effective_date") }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>} */}
                    </Grid>
                    {data?.ad_assessment ? null : <Grid spacing={1} container>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="A/C Comp"
                                id="ac_comp"
                                inputProps={{ maxLength: 200 }}
                                fullWidth
                                margin='normal'
                                InputLabelProps={{ shrink: true }}
                                value={data?.ac_comp}
                                onChange={(e) => onFieldChange("ac_comp", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <Autocomplete
                                id="ad_compliance_status"
                                options={['OPEN', 'COMPLIED', 'PARTIALLY COMPLIED', 'NOT APPLICABLE']}
                                getOptionLabel={option => option}
                                margin='normal'
                                value={data?.ad_compliance_status || null}
                                onChange={(e, value) => onFieldChange("ad_compliance_status", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Compliance Status"
                                        placeholder="Select Compliance Status"
                                        variant="outlined"
                                        fullWidth
                                        margin='normal'
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label={
                                    <span style={{ verticalAlign: 'super' }}>
                                        AD Compliance TSN
                                        <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 99999.99</span>} arrow>
                                            <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                        </Tooltip>
                                    </span>
                                }
                                id="ad_compliance_tsn"
                                fullWidth
                                margin='normal'
                                inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data?.ad_compliance_tsn) && 10 }}
                                disabled={data?.ad_compliance_status === "NOT APPLICABLE" || data?.ad_assessment_status === "COMPLETED"}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                value={regexConstants.alphanumespcespclchar.test(data?.ad_compliance_tsn) ? data?.ad_compliance_tsn : format_Commas(data?.ad_compliance_tsn.replace(/[^0-9.]/g, ''))}
                                error={error.ad_compliance_tsn ? true : false}
                                helperText={error.ad_compliance_tsn ? error.ad_compliance_tsn : ""}
                                o onChange={(e) => {
                                    const value = format_Commas(e.target.value).replace(/[^0-9.]/g, '');
                                    const numericValue = value.replace(/[^\d.]/g, '');
                                    const dotCount = (numericValue.match(/\./g) || []).length;
                                    const isValid = dotCount ? (numericValue.replace(".", "").length - dotCount <= 6 && regexConstants.numberWithDot.test(numericValue)) : value.length <= 5 && regexConstants.numberWithDot.test(numericValue);
                                    if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                        onFieldChange("ad_compliance_tsn", e.target.value);
                                        setError({ ...error, ad_compliance_tsn: e.target.value === (null || undefined || "") ? "" : !specificKey.includes(e.target.value.toUpperCase()) && specificMessTsn })
                                    } else if (isValid || value === "") {
                                        onFieldChange("ad_compliance_tsn", numericValue);
                                        setError({ ...error, ad_compliance_tsn: regexConstants.numberWithDot.test(numericValue) || e.target.value === (null || undefined || "") ? "" : e.target.value === null ? "" : "" })
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label={
                                    <span style={{ verticalAlign: 'super' }}>
                                        AD Compliance CSN
                                        <Tooltip placement='right' title={<span>Allow Keywords - NA, N/A,Unknown,UNK or 99999</span>} arrow>
                                            <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                                        </Tooltip>
                                    </span>
                                }
                                name="ad_compliance_csn"
                                id="ad_compliance_csn"
                                fullWidth
                                margin='normal'
                                inputProps={{ maxLength: regexConstants.alphanumespcespclchar.test(data?.ad_compliance_csn) ? 8 : 6 }}
                                disabled={data?.ad_compliance_status === "NOT APPLICABLE" || data?.ad_assessment_status === "COMPLETED"}
                                InputLabelProps={{ shrink: true, style: { pointerEvents: 'auto' } }}
                                error={error.ad_compliance_csn ? true : false}
                                helperText={error.ad_compliance_csn ? error.ad_compliance_csn : ""}
                                value={regexConstants.alphanumespcespclchar.test(data?.ad_compliance_csn) ? data?.ad_compliance_csn : format_Commas(data?.ad_compliance_csn.toString().replace(/[^0-9.]/g, ''))}
                                onChange={(e) => {
                                    if (regexConstants.alphanumespcespclchar.test(e.target.value)) {
                                        onFieldChange("ad_compliance_csn", e.target.value);
                                        setError({ ...error, ad_compliance_csn: e.target?.value === null || e.target?.value === "" ? "" : !specificKey.includes(e.target.value.toUpperCase()) && specificMessCsn })

                                    } else {
                                        e.target.value.length <= 6 && (regexConstants.onlyNumeric.test(format_Commas(e.target.value).replace(/[^0-9.]/g, '')) || e.target.value === "") && onFieldChange('ad_compliance_csn', e.target.value)
                                        setError({ ...error, ad_compliance_csn: e.target?.value === null || regexConstants.numberWithComma.test(e.target.value) || e.target?.value === "" ? "" : "" })
                                    }
                                }
                                }
                            />
                        </Grid>

                    </Grid>}
                    {data?.ad_assessment ? null : <Grid spacing={1} container>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Type"
                                id="type"
                                fullWidth
                                margin='normal'
                                inputProps={{ maxLength: 200 }}
                                required={acumenCamo ? false :!smbcInstance }
                                InputLabelProps={{ shrink: true }}
                                error={error?.type ? true : false}
                                helperText={error?.type ? error?.type : ""}
                                value={data?.type}
                                onChange={(e) => { onFieldChange("type", e.target.value); onRestErrorKey("type") }}
                                disabled={data?.ad_assessment_status === "COMPLETED"}

                            />
                        </Grid>
                        {/* {smbcInstance ? */}
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Reference"
                                name="reference"
                                fullWidth
                                inputProps={{ maxLength: 256 }}
                                margin='normal'
                                InputLabelProps={{ shrink: true }}
                                value={data?.reference}
                                onChange={(e) => onFieldChange("reference", e.target.value)}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        {/* : null} */}
                        <Grid item xs={12} md={3} sm={3}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    label="Date of compliance"
                                    // label={<> Date of compliance {data?.ad_compliance_status !== "COMPLIED" ? null : (smbcInstance ? null : <span style={{ color: "red" }}> *</span>)} </>}
                                    id="ad_compliance_date"
                                    format={dayMonthDateFormat}
                                    inputVariant="outlined"
                                    fullWidth
                                    margin='normal'
                                    disableFuture
                                    InputLabelProps={{ shrink: true }}
                                    minDate={moment().subtract(25, "years")}
                                    error={error?.ad_compliance_date ? true : false}
                                    helperText={error?.ad_compliance_date ? error?.ad_compliance_date : ""}
                                    value={data?.ad_compliance_date || null}
                                    onPaste={(event) => event.preventDefault()}
                                    onChange={(data) => { onFieldChange("ad_compliance_date", moment(data).format(backendDateFormat)); onRestErrorKey("ad_compliance_date") }}
                                    disabled={data?.ad_assessment_status === "COMPLETED"}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Reference Documents"
                                id="ref_documents"
                                margin='normal'
                                required={acumenCamo ? false :!smbcInstance }
                                error={error?.ref_documents ? true : false}
                                helperText={error?.ref_documents ? error?.ref_documents : ""}
                                multiline
                                fullWidth
                                inputProps={{ maxLength: 200 }}
                                InputLabelProps={{ shrink: true }}
                                value={data?.ref_documents}
                                onChange={(e) => { onFieldChange("ref_documents", e.target.value); onRestErrorKey("ref_documents") }}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} sm={3}>
                            <TextField
                                variant="outlined"
                                label="Workorder"
                                id="workorder"
                                margin='normal'
                                multiline
                                fullWidth
                                inputProps={{ maxLength: 500 }}
                                InputLabelProps={{ shrink: true }}
                                required={acumenCamo ? false :!smbcInstance }
                                disabled={data?.ad_compliance_status === "NOT APPLICABLE" || data?.ad_assessment_status === "COMPLETED"}
                                error={error?.workorder ? true : false}
                                helperText={error?.workorder ? error?.workorder : ""}
                                value={data?.workorder}
                                onChange={(e) => { onFieldChange("workorder", e.target.value); onRestErrorKey("workorder") }}
                            />
                        </Grid>
                    </Grid>}
                    {data?.ad_assessment ? null : <Grid spacing={1} container>
                        <Grid item xs={12} md={4} sm={4}>
                            <FormControl>
                                <FormLabel component="legend">AD Compliance DFP {(acumenCamo || smbcInstance) ? null : <span style={{ color: "red" }}> *</span>}</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="ad_compliance_dfp"
                                    name="ad_compliance_dfp"
                                    defaultValue="top"
                                    value={data?.ad_compliance_dfp}
                                    onChange={(e) => { onFieldChange("ad_compliance_dfp", e.target.value); onRestErrorKey("ad_compliance_dfp") }}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio size="small" color="primary" />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio size="small" color="primary" />}
                                        label="No"
                                    />
                                </RadioGroup>
                                {error?.ad_compliance_dfp && (
                                    <span style={{ color: "red", fontSize: "0.75rem" }}>
                                        {error?.ad_compliance_dfp}
                                    </span>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4} sm={4}>
                            <FormControl>
                                <FormLabel component="legend">Release certificate</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="release_certificate"
                                    name="release_certificate"
                                    defaultValue="top"
                                    value={data?.release_certificate}
                                    onChange={(e) => onFieldChange("release_certificate", e.target.value)}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio size="small" color="primary" />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio size="small" color="primary" />}
                                        label="No"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4} sm={4}>
                            <FormControl>
                                <FormLabel component="legend">Certificate of Conformity</FormLabel>
                                <RadioGroup
                                    row
                                    aria-label="conformity_crt"
                                    name="conformity_crt"
                                    defaultValue="top"
                                    value={data?.conformity_crt}
                                    onChange={(e) => onFieldChange("conformity_crt", e.target.value)}
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio size="small" color="primary" />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio size="small" color="primary" />}
                                        label="No"
                                    />
                                    <FormControlLabel
                                        value="N/A"
                                        control={<Radio size="small" color="primary" />}
                                        label="N/A"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>}
                    <Grid container spacing={1} style={{ backgroundColor: data?.ad_assessment ? '#e5e5e5' : '', padding: data?.ad_assessment ? '10px' : '' }}>
                        {data?.ad_assessment ? <>
                            <Grid item xs={12} md={1} sm={1} style={{ alignContent: "center" }}>
                                <Tooltip title={data?.esn_range ? "Click to enter ESN" : "Click to enter ESN Range"}>
                                    <Switch
                                        checked={data?.esn_range}
                                        onChange={(e) => onFieldChange("esn_range", e.target.checked)}
                                        name="esn_range"
                                        margin='normal'
                                        fullWidth
                                        disabled={data?.id}
                                        color='primary'
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} md={3} sm={3}>
                                {data?.esn_range ?
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <TextField
                                            variant="outlined"
                                            label="ESN From"
                                            fullWidth
                                            margin='normal'
                                            disabled={data?.id}
                                            InputLabelProps={{ shrink: true }}
                                            value={esnFrom ? esnFrom : data?.esnFrom || ""}
                                            onChange={(e) => onFieldChange("esnFrom", e.target.value)}
                                        />
                                        <Typography variant="h6" style={{ marginInline: '10px' }}>-</Typography>
                                        <TextField
                                            variant="outlined"
                                            label="ESN To"
                                            fullWidth
                                            margin='normal'
                                            disabled={data?.id}
                                            InputLabelProps={{ shrink: true }}
                                            value={esnTo ? esnTo : data?.esnTo || ""}
                                            onChange={(e) => onFieldChange("esnTo", e.target.value)}
                                        />
                                    </Box>
                                    :
                                    <TextField
                                        variant="outlined"
                                        label="ESN"
                                        id="esn_list"
                                        margin='normal'
                                        multiline
                                        fullWidth
                                        disabled={data?.id}
                                        // inputProps={{ maxLength: 500 }}
                                        InputLabelProps={{ shrink: true }}
                                        error={error?.esn_list ? true : false}
                                        helperText={error?.esn_list ? error?.esn_list : ""}
                                        value={data?.esn_list || ''}
                                        onChange={(e) => { onFieldChange("esn_list", e.target.value); onRestErrorKey("esn_list") }}
                                        onBlur={(e) => data?.applicability && data?.esn_list ? activeActiveApplicabilty(e.target.value) : e.preventDefault()}
                                    />
                                }
                            </Grid>
                            <Grid item xs={12} md={4} sm={4}>
                                <TextField
                                    variant="outlined"
                                    label="Part Number"
                                    id="part_number_list"
                                    margin='normal'
                                    multiline
                                    fullWidth
                                    disabled={data?.id}
                                    InputLabelProps={{ shrink: true }}
                                    error={error?.part_number_list ? true : false}
                                    helperText={error?.part_number_list ? error?.part_number_list : ""}
                                    value={data?.part_number_list}
                                    onChange={(e) => { onFieldChange("part_number_list", e.target.value); onRestErrorKey("part_number_list") }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sm={4}>
                                <TextField
                                    variant="outlined"
                                    label="Serial Number"
                                    id="serial_number_list"
                                    margin='normal'
                                    multiline
                                    fullWidth
                                    disabled={data?.id}
                                    InputLabelProps={{ shrink: true }}
                                    error={error?.serial_number_list ? true : false}
                                    helperText={error?.serial_number_list ? error?.serial_number_list : ""}
                                    value={data?.serial_number_list}
                                    onChange={(e) => { onFieldChange("serial_number_list", e.target.value); onRestErrorKey("serial_number_list") }}
                                />
                            </Grid></> : null}
                        <Grid item xs={12} md={6} sm={6}>
                            <TextField
                                label="Remarks"
                                margin='normal'
                                variant='outlined'
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => onFieldChange("remark", e.target.value)}
                                rows={3}
                                multiline
                                value={data?.remark || ''}
                                disabled={data?.ad_assessment_status === "COMPLETED"}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6} style={{ marginTop: "15px" }}>
                            <div className="upload-amp-textbox" style={{ border: "1px solid #cfc1c1", textAlign: 'center', padding: "35px", borderRadius: "3px" }}>
                                <span onClick={(e) => data?.assessment_job_id ? e.preventDefault() : setUploadFile(true)} style={{ cursor: data?.assessment_job_id ? 'not-allowed' : 'pointer' }}><AttachmentIcon color='primary' fontSize='small' style={{ verticalAlign: 'middle', display: data?.assessment_job_id ? 'none' : '' }} /> {data?.assessment_job_id ? "Uploaded File" : "Upload File"}</span>
                                <div style={{ overflow: "auto" }}>
                                    {data?.attachments?.length > 0 && data?.attachments?.map((attachments) =>
                                        <>{attachments.name}
                                            <a href={decodeURIComponent(attachments.file)} download={attachments.file_name}><GetAppIcon color="primary" style={{ fontSize: 'medium', verticalAlign: 'middle' }} /></a>
                                            <CloseIcon disabled={data?.assessment_job_id} onClick={() => onRemoveUploadFile(attachments)} color='secondary' style={{ fontSize: 'medium', verticalAlign: 'middle', display: data?.assessment_job_id ? 'none' : '' }} />
                                        </>
                                    )}
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12} sm={12}>
                            {data?.assessment_job_id ? <StepperFile assessmentData={assessmentData} /> : null}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            {data?.assessment_job_id ?
                                <AssessmentList
                                    mainData={data}
                                    assessmentData={assessmentData}
                                    setAssessmentData={setAssessmentData}
                                    onChangeAssessment={onChangeAssessment}
                                    moduleName='ad'
                                /> : null}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color='primary' size='small' onClick={toggleModalFn}>CLOSE</Button>
                    {data?.assessment_job_id ? <>
                        {data?.ad_assessment_status === "COMPLETED" ? null : <Button  disabled={assessmentData?.status !== "COMPLETED"} variant='contained' color='primary' size='small' onClick={() => setAsseementFinalSave({ modal: true })}>SAVE CHANGES</Button>}</> :
                        data?.ad_assessment ? <Button variant='contained' color='primary' onClick={()=>onAddNewAsset("PROCESS")}>PROCESS</Button>
                            :
                            <Button variant='contained' color='primary' size='small' onClick={()=>onAddNewAsset("SAVE")}>SAVE</Button>
                    }
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
            {
                assessmentFinalSave?.modal ?
                    <DeletePopUp
                        title='Save AD Assessment'
                        deleteRecordFn={() => onSaveChanges()}
                        modal={() => setAsseementFinalSave({ modal: true })}
                        content='Once you save assessment you are not able to edit assessment again,are you sure ?'
                        toggleModalFn={() => setAsseementFinalSave({ modal: false })}
                        confirmText="SAVE"
                        confirmColor="primary"
                    /> : null
            }
            {
                uploadFile ?
                    <Dialog
                        open={true}
                        onClose={() => setUploadFile(false)}
                        className='camo-management-modal'
                        maxWidth={'md'}
                    >
                        <DialogTitle id="scroll-dialog-title">
                            Upload AD  File
                        </DialogTitle>
                        <DialogContent dividers={true}>
                            <div style={{ width: '380px' }}>
                                <div>
                                    <DropzoneArea
                                        filesLimit={5}
                                        maxFileSize={104857600}
                                        showPreviewsInDropzone={false}
                                        useChipsForPreview={true}
                                        showPreviews={true}
                                        dropzoneText={<p>Drag & Drop file Or Click Here </p>}
                                        dropzoneClass="drag-drop-cnt"
                                        maxWidth="sm"
                                        showAlerts={['info', 'error']}
                                        alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                        clearOnUnmount={true}
                                        onChange={(value) => onFieldChange("attachments", value)}
                                    />
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button disabled={isLoading} onClick={() => setUploadFile(false)} color='primary' size='small' variant='outlined'>CLOSE</Button>
                            <Button onClick={() => setUploadFile(false)} color='primary' size='small' variant='contained'>
                                {isLoading ? <CircularProgress size={24} color='white' /> : 'SAVE'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    : null

            }
        </>
    )
}
export default AddEditFleetAD;